import Alert from "@mui/material/Alert";
import Tooltip from "@mui/material/Tooltip";
import Switch from '@mui/material/Switch';
import { TableRow } from "../../UI/TableRow";
import { TableCell } from "../../UI/TableCell";
import { Typography } from "../../UI/Typography";
import { Grid } from "../../UI/Grid";
import { MatchDatesAccordionBody } from "./MatchDatesAccordionBody";
import { TablePagination } from "../TablePagination";
import { useMatchDates } from "./useMatchDates";
const IDENTICAL_DATES_WARNING = 'One or more of your matching rounds have the same date for opening and closing of matching. Users in this matching round(s) can only fill out their matching profile and cannot self-select roommates.';

export const MatchDatesAccordion = () => {
  const { rows, rowsSameDate, isLoading, showArchived, handleToggleArchiveChange } = useMatchDates();

  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center" mb={2}>
        <Grid item>
          <Typography variant="body2">
            Registration and matching <strong>start dates</strong> begin at 12:01am PST on the date shown.  Registration and matching <strong>end dates</strong> close at 12:01am PST the day after the date shown
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body2">
            Show Archived
            <Switch value={showArchived} onChange={handleToggleArchiveChange}/>
          </Typography>
        </Grid>
      </Grid>
      <MatchDatesAccordionBody rows={rows} isLoading={isLoading} />
        {
          rowsSameDate
            ? (
              <Tooltip title={rowsSameDate} placement="top">
                <TableRow variant="footer">
                  <TableCell colSpan={4} variant="footer">
                    <Alert severity="warning">
                      {IDENTICAL_DATES_WARNING}
                    </Alert>
                  </TableCell>
                </TableRow>
              </Tooltip>
            ) : null
        }
      <TablePagination />
    </>
  );
};
